import React, { useState, useEffect } from 'react'
import DepositService from '../services/DepositService'
import NewDepositModal from './modals/NewDepositModal';
import GmoService from './../services/GmoService';
import ConfiguracaoService from '../services/ConfiguracaoService';
import * as XLSX from 'xlsx';

// Mesma chave de vision_be/enums/ChavesConfiguracao.js
const CHAVE_EMAILS_ALERTA = 'emails_alerta_movimentacao';

export default function Admin() {

    const [depositList, setDepositList] = useState([]);
    const [gmoList, setGmoList] = useState([]);
    const [ufFilterDeposit, setUfFilterDeposit] = useState()
    const [newDepositModal, setNewDepositModal] = useState(false)

    // ── Alertas de movimentação: e-mails que a portaria recebe ──────────────
    const [emails, setEmails] = useState([]);
    const [emailsSalvos, setEmailsSalvos] = useState([]); // referência para saber o que mudou
    const [novoEmail, setNovoEmail] = useState('');
    const [salvandoEmails, setSalvandoEmails] = useState(false);
    const [mensagemEmails, setMensagemEmails] = useState(null);
    const [alteradoPor, setAlteradoPor] = useState(null);
    const [alteradoEm, setAlteradoEm] = useState(null);

    const emailsAlterados = JSON.stringify(emails) !== JSON.stringify(emailsSalvos);

    const aplicarConfig = (config) => {
        const lista = Array.isArray(config?.valor) ? config.valor : [];
        setEmails(lista);
        setEmailsSalvos(lista);
        setAlteradoPor(config?.atualizadoPor || null);
        setAlteradoEm(config?.atualizadoEm || null);
    };

    useEffect(() => {
        ConfiguracaoService.getConfiguracao(CHAVE_EMAILS_ALERTA).then((config) => {
            if (config) aplicarConfig(config);
        });
    }, []);

    const handleAdicionarEmail = () => {
        const email = novoEmail.trim().toLowerCase();
        if (!email) return;

        // Mesma validação do backend, para o erro aparecer antes de ir ao servidor.
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
            setMensagemEmails({ erro: true, texto: `E-mail inválido: ${email}` });
            return;
        }
        if (emails.includes(email)) {
            setMensagemEmails({ erro: true, texto: 'Este e-mail já está na lista.' });
            return;
        }

        setEmails([...emails, email]);
        setNovoEmail('');
        setMensagemEmails(null);
    };

    const handleRemoverEmail = (email) => {
        setEmails(emails.filter((e) => e !== email));
        setMensagemEmails(null);
    };

    const handleSalvarEmails = async () => {
        setSalvandoEmails(true);
        setMensagemEmails(null);
        try {
            const config = await ConfiguracaoService.salvarConfiguracao(CHAVE_EMAILS_ALERTA, emails);
            aplicarConfig(config);
            setMensagemEmails({ erro: false, texto: 'Lista salva.' });
        } catch (error) {
            setMensagemEmails({
                erro: true,
                texto: error.response?.data?.message || 'Não foi possível salvar a lista.',
            });
        }
        setSalvandoEmails(false);
    };

    // function formatarCep(cep) {
    //     if (cep) return cep.replace(/^(\d{5})(\d{3})$/, '$1-$2');
    //     return ''
    //   }

    useEffect(()=>{

        const fetchData = async () =>{

            const params = new URLSearchParams();
            if (ufFilterDeposit) params.append('uf', ufFilterDeposit);

            const queryStringDeposit = params.toString();
            const deposits = await DepositService.getDeposits(`?${queryStringDeposit}`);

            const gmos = await GmoService.getGmos();

            setDepositList(deposits);
            setGmoList(gmos);

        }

        fetchData();       

    }, [ufFilterDeposit])
    
    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

            // Remove a primeira linha (cabeçalho) dos dados
            jsonData.shift();

            const gmos = jsonData.map((row) => ({
                cidade: row[3],
                uf: row[4],
                endereco: row[5],
                daOrigem: row[6]
            }));

            await GmoService.importarGmos(gmos);
            console.log('GMOs importados com sucesso');
        };
        reader.readAsArrayBuffer(file);
    };


  return (
    <div className="flex w-full h-full justify-center items-center py-4 px-4 bg-gray-200">
        <div className="flex flex-col w-full min-h-full rounded-xl py-8 px-6 gap-4 bg-white">
            <div className="w-full text-md font-semibold">
                Painel Admin
            </div>

            <div className='w-full flex flex-col gap-2'>
                <div className='flex justify-between'>
                    <div className="w-full text-sm font-semibold">
                        Depósitos
                    </div>
                    <button 
                        onClick={()=>setNewDepositModal(true)}
                        className='bg-gray-800 whitespace-nowrap text-white rounded-md px-2'
                        >
                        + Novo Depósito
                    </button>
                </div>

                <div className="w-full">
                    <div className="overflow-x-auto">
                    <table className="min-w-full bg-white rounded-lg text-xs">
                        <thead className="bg-neutral-200">
                        <tr>
                            <th className="py-2 px-4 border-b rounded-tl-lg">Status</th>
                            <th className="py-2 px-4 border-b">Sigla</th>
                            <th className="py-2 px-4 border-b">Cidade</th>
                            <th className="py-2 px-4 border-b">Estado</th>
                            <th className="py-2 px-4 border-b">Endereço</th>
                            <th className="py-2 px-4 border-b">CEP</th>
                            <th className="py-2 px-4 border-b rounded-tr-lg">Cód SGS</th>
                        </tr>
                        </thead>
                        <tbody>
                        {depositList.deposits?.map((deposit, index) => (
                            <tr key={index} className={`border-b hover:bg-gray-100`}>
                            <td className="py-1 px-4"><div className='flex justify-center items-center'>{deposit.status}</div></td>
                            <td className="py-1 px-4"><div className='flex justify-center items-center'>{deposit.sigla}</div></td>
                            <td className="py-1 px-4"><div className='flex justify-center items-center'>{deposit.cidade}</div></td>
                            <td className="py-1 px-4"><div className='flex justify-center items-center'>{deposit.uf}</div></td>
                            <td className="py-1 px-4"><div className='flex justify-start items-center'>{deposit.endereco}</div></td>
                            <td className="py-1 px-4"><div className='flex justify-start items-center'>{deposit.cep}</div></td>
                            <td className="py-1 px-4"><div className='flex justify-start items-center'>{deposit.codSGS}</div></td>
                            {/* <td className="py-1 px-4">
                                <div className="flex justify-center gap-2">
                                <button
                                    className=" bg-sky-700 rounded-full px-2 py-1 text-white text-sm"
                                    onClick={()=>handleAnswerRequest(request._id, request.idRequest)}
                                >
                                    Atender
                                </button>
                                <button 
                                    className=" bg-gray-700 rounded-full px-2 py-1 text-white text-sm"
                                    onClick={()=>handleBackOfficeModal(request._id, request.idRequest)}
                                >
                                    Voltar
                                </button>
                                </div>
                            </td> */}
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    </div>
                </div>


            </div>

            <div className='w-full flex flex-col gap-2'>
                <div className='flex justify-between gap-2'>
                    <div className="w-full text-sm font-semibold">
                        GMOs
                    </div>
                    {/* <button 
                        onClick={()=>{}}
                        className='bg-gray-800 whitespace-nowrap text-white rounded-md px-2'
                        >
                        + Novo GMO
                    </button> */}
                    {/* <button 
                        onClick={()=>{}}
                        className='bg-green-600 whitespace-nowrap text-white rounded-md px-2'
                        >
                        Importação Massiva
                    </button> */}
                    <input type="file" onChange={handleFileUpload} />
                </div>

                <div className="w-full">
                    <div className="overflow-x-auto">
                    <table className="min-w-full bg-white rounded-lg text-xs">
                        <thead className="bg-neutral-200">
                        <tr>
                            <th className="py-2 px-4 border-b rounded-tl-lg">Status</th>
                            <th className="py-2 px-4 border-b">Cidade</th>
                            <th className="py-2 px-4 border-b">Estado</th>
                            <th className="py-2 px-4 border-b">Endereço</th>
                            <th className="py-2 px-4 border-b">DA de Origem</th>
                            <th className="py-2 px-4 border-b rounded-tr-lg">Sigla DA Origem</th>
                        </tr>
                        </thead>
                        <tbody>
                        {gmoList.gmos?.map((gmo, index) => (
                            <tr key={index} className={`border-b hover:bg-gray-100`}>
                            <td className="py-1 px-4"><div className='flex justify-center items-center'>{gmo.status}</div></td>
                            <td className="py-1 px-4"><div className='flex justify-center items-center'>{gmo.cidade}</div></td>
                            <td className="py-1 px-4"><div className='flex justify-center items-center'>{gmo.uf}</div></td>
                            <td className="py-1 px-4"><div className='flex justify-center items-center'>{gmo.endereco}</div></td>
                            <td className="py-1 px-4"><div className='flex justify-center items-center'>{gmo.depositoOrigem.cidade}</div></td>
                            <td className="py-1 px-4"><div className='flex justify-center items-center'>{gmo.depositoOrigem.sigla}</div></td>
                            {/* <td className="py-1 px-4">
                                <div className="flex justify-center gap-2">
                                <button
                                    className=" bg-sky-700 rounded-full px-2 py-1 text-white text-sm"
                                    onClick={()=>handleAnswerRequest(request._id, request.idRequest)}
                                >
                                    Atender
                                </button>
                                <button 
                                    className=" bg-gray-700 rounded-full px-2 py-1 text-white text-sm"
                                    onClick={()=>handleBackOfficeModal(request._id, request.idRequest)}
                                >
                                    Voltar
                                </button>
                                </div>
                            </td> */}
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    </div>
                </div>


            </div>

            {/* ── Alertas de movimentação ───────────────────────────────── */}
            <div className='w-full flex flex-col gap-2 mt-4'>
                <div className='flex justify-between items-center'>
                    <div className="w-full text-sm font-semibold">
                        Alertas de movimentação — e-mails da portaria
                    </div>
                    {alteradoPor && (
                        <span className="text-[11px] text-gray-500 whitespace-nowrap">
                            Alterado por {alteradoPor}{alteradoEm ? ` em ${new Date(alteradoEm).toLocaleString('pt-BR')}` : ''}
                        </span>
                    )}
                </div>

                <p className="text-xs text-gray-600 max-w-3xl">
                    Quem recebe o aviso de saída de material do depósito. Sem nenhum e-mail aqui,
                    as movimentações continuam acontecendo e <strong>nenhum alerta é enviado</strong>.
                </p>

                <div className="flex flex-col gap-2 max-w-xl">
                    <div className="flex gap-2">
                        <input
                            type="email"
                            value={novoEmail}
                            onChange={(e) => setNovoEmail(e.target.value)}
                            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleAdicionarEmail(); } }}
                            placeholder="portaria@amerinode.com.br"
                            className="w-full rounded-md px-3 py-1 text-sm text-gray-900 border border-zinc-400 outline-none"
                        />
                        <button
                            type="button"
                            onClick={handleAdicionarEmail}
                            className="bg-gray-800 whitespace-nowrap text-white rounded-md px-3 text-sm"
                        >
                            + Adicionar
                        </button>
                    </div>

                    {emails.length === 0 ? (
                        <span className="text-xs text-red-700">
                            Nenhum e-mail cadastrado — nenhum alerta será enviado.
                        </span>
                    ) : (
                        <ul className="flex flex-col gap-1">
                            {emails.map((email) => (
                                <li key={email} className="flex items-center justify-between bg-gray-100 rounded-md px-3 py-1">
                                    <span className="text-xs text-gray-800">{email}</span>
                                    <button
                                        type="button"
                                        onClick={() => handleRemoverEmail(email)}
                                        className="text-xs text-red-700 hover:underline"
                                    >
                                        remover
                                    </button>
                                </li>
                            ))}
                        </ul>
                    )}

                    {mensagemEmails && (
                        <span className={`text-xs ${mensagemEmails.erro ? 'text-red-700' : 'text-green-700'}`}>
                            {mensagemEmails.texto}
                        </span>
                    )}

                    <div className="flex gap-2 items-center">
                        <button
                            type="button"
                            disabled={salvandoEmails || !emailsAlterados}
                            onClick={handleSalvarEmails}
                            className="bg-blue-600 text-white rounded-md px-4 py-1 text-sm disabled:bg-gray-300"
                        >
                            {salvandoEmails ? 'Salvando...' : 'Salvar'}
                        </button>
                        {emailsAlterados && !salvandoEmails && (
                            <span className="text-[11px] text-amber-700">Alterações não salvas</span>
                        )}
                    </div>
                </div>
            </div>

        </div>

        <div className="absolute">
        <NewDepositModal
          isModalOpen={newDepositModal}
          setModalOpen={() => {
            setNewDepositModal(!newDepositModal);
          }}
        ></NewDepositModal>
      </div>


    </div>
  )
}
